export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/social_media_design.f8bf545.svg";